import type { IStyle } from '@fluentui/react';

export type StyleClassName<T extends string> = {
  [key in T]?: string;
};

export type IStyles<T extends string | number | symbol> = {
  [key in T]?: IStyle;
};

export const joinedButtonsStyles = {
  root: {
    button: { borderRadius: '0 0 0 0' },
    '.h2o-ButtonContainer-root:first-child button': { borderRadius: '4px 0 0 4px' },
    '.h2o-ButtonContainer-root:last-child button': { borderRadius: '0 4px 4px 0' },
    '.h2o-ButtonContainer-root:not(:first-child) button': { borderLeftWidth: 0 },
  },
};
